/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/workflows', {
      templateUrl: 'modules/app/workflows/workflows.html',
      controller: 'WorkflowsCtrl',
      resolve: {
        include: function include() {
          return 'manage';
        }
      }
    }).when('/settings/workflows/jobs', {
      templateUrl: 'modules/app/workflows/workflows.html',
      controller: 'WorkflowsCtrl',
      resolve: {
        include: function include() {
          return 'jobs';
        }
      }
    }).when('/settings/workflows/:workflowId', {
      templateUrl: 'modules/app/workflows/workflows.html',
      controller: 'WorkflowsCtrl',
      resolve: {
        include: function include() {
          return 'edit';
        }
      }
    }).when('/settings/workflows/:workflowId/debug', {
      templateUrl: 'modules/app/workflows/workflows.html',
      controller: 'WorkflowsDebugCtrl',
      resolve: {
        include: function include() {
          return 'debug';
        }
      }
    });
  }]).controller('WorkflowsManageCtrl', ['$scope', '$q', '$filter', 'Workflows', 'wsEventNames', 'Alerts', '$location', 'Logger', '$timeout', 'WorkflowsRegistry', function ($scope, $q, $filter, Workflows, wsEventNames, Alerts, $location, Logger, $timeout, WorkflowsRegistry) {
    $scope.fetchWorkflowsPage = function () {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      return WorkflowsRegistry.get(offset, limit).then(function (response) {
        $scope.workflows = response.results;
        return response;
      });
    };
    $scope.onPagerLoaded = function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    };
  }]).controller('WorkflowsCtrl', ['include', '$scope', '$q', '$filter', 'Workflows', 'wsEventNames', 'Alerts', '$location', 'Logger', 'WorkflowsRegistry', 'OrganizationSettings', 'UserRoles', 'User', function (include, $scope, $q, $filter, Workflows, wsEventNames, Alerts, $location, Logger, WorkflowsRegistry, OrganizationSettings, UserRoles, User) {
    var workflowsNotEnabled = !OrganizationSettings.hasFeature('workflows');
    var userNotAdmin = !UserRoles.isOrgAdmin(User.get());
    if (workflowsNotEnabled || userNotAdmin) {
      $location.path('/');
    }
    $scope.include = include;
    $scope.section = 'workflows';
    $scope.workflowsNav = [{
      display: 'Workflows',
      condition: true,
      section: 'workflows'
    }, {
      display: 'Jobs',
      condition: true,
      section: 'jobs'
    }];
    $scope.activeWorkflowsNav = 0;
    $scope.setActiveWorkflowsNav = function (index) {
      $scope.activeWorkflowsNav = index;
    };
    $scope.delete = function (workflowToDelete) {
      WorkflowsRegistry.deleteOne(workflowToDelete.id).then(function () {
        Alerts.raiseAlert({
          type: 'success',
          text: "Successfully deleted workflow with ID: ".concat(workflowToDelete.id),
          autoDismissTimeout: 3000
        });
        $scope.$broadcast(wsEventNames.pager.setPage, 1);
      }, function (err) {
        Logger.error('Error while deleting workflow', err);
      });
    };
    $scope.create = function () {
      $location.path("/settings/workflows/new");
    };
    $scope.setActive = function (workflow, isActive) {
      WorkflowsRegistry.update(Object.assign({}, workflow, {
        active: isActive
      })).then(function () {
        Alerts.raiseAlert({
          type: 'success',
          text: "".concat(isActive ? 'Activated' : 'Deactivated', " ").concat(workflow.name),
          autoDismissTimeout: 1500
        });
        workflow.active = isActive;
      }, function (err) {
        var text = "Encountered an error while trying to ".concat(isActive ? 'activate' : 'deactivate', " workflow.");
        if (err.data.message) {
          text = err.data.message;
        }
        Logger.error('Error while trying to deactivate workflow:', err);
        Alerts.raiseAlert({
          type: 'danger',
          text: text,
          autoDismissTimeout: 1500
        });
      });
    };
    $scope.testRunWorkflow = function (id) {
      return $location.path("/settings/workflows/".concat(id, "/debug"));
    };
  }]).controller('WorkflowsEditCtrl', ['$scope', 'Workflows', '$routeParams', 'Logger', 'Alerts', '$location', 'Utils', 'WorkflowsRegistry', 'AceUtils', 'User', function ($scope, Workflows, $routeParams, Logger, Alerts, $location, Utils, WorkflowsRegistry, AceUtils, User) {
    $scope.workflowId = $routeParams.workflowId;
    $scope.isNewWorkflow = $scope.workflowId === 'new';
    $scope.debugBtn = {
      icon: 'play-circle',
      saving: false
    };
    var originalWorkflow = null;
    var defaultWorkflow = {
      name: 'New Workflow',
      triggers: [],
      actions: [],
      context: {
        contextExampleCount: 0,
        myName: User.get().user.name || 'Valued Watershed User'
      }
    };
    if ($scope.isNewWorkflow) {
      $scope.save = createWorkflow;
      $scope.workflow = defaultWorkflow;
      originalWorkflow = angular.copy($scope.workflow);
    } else {
      $scope.save = updateWorkflow;
      WorkflowsRegistry.getOne($scope.workflowId).then(function (response) {
        if (response === null) {
          $scope.error = {
            general: {
              msg: "We could not find workflow with id: ".concat($scope.workflowId, ".")
            }
          };
        } else {
          $scope.workflow = angular.copy(response); // Modifiable
          originalWorkflow = angular.copy(response); // Original reference
          setAceValue();
        }
      }).catch(function (err) {
        Logger.error("Error while getting workflow:", err);
        $scope.error = {
          general: {
            msg: err.msg ? err.msg : err
          }
        };
      });
    }
    $scope.addQuickTask = function (type) {
      var tasks = {
        COMPARE: {
          type: 'COMPARE',
          operator: '!=',
          first: 'triggers[0].count',
          second: 'contextExampleCount'
        },
        EMAIL_REPORT: {
          type: 'EMAIL_REPORT',
          subject: 'Subject Line',
          bodyIntro: 'This will appear in your email body. Note: If you include bodyTemplate, it will not show bodyIntro.',
          bodyTemplate: '{{myName}}, You can use templates here that reference the context: {{contextExampleCount}}',
          subscribers: [{
            email: User.get().user.email || 'test@example.com'
          }]
        },
        LOOP: {
          type: 'LOOP',
          loopContextPath: 'actions[0].data',
          taskToRun: {
            type: 'REST_REQUEST',
            httpMethod: 'POST',
            url: 'https://example.com/api/',
            username: 'user@example.com',
            password: 'sTrOnGpAsSwOrD9001',
            params: {
              'paramsPassed': true
            },
            headers: {
              'Content-Type': 'application/json'
            },
            body: 'The body can use context! -> {{ contextExampleCount }}'
          }
        },
        REPORT: {
          type: 'REPORT',
          config: {
            filter: {
              activityIds: null,
              personIds: [],
              groupIds: null,
              dateFilter: {
                dateType: "none",
                trailingAmount: 1,
                trailingType: "days",
                customDateFrom: null,
                customDateTo: null
              }
            },
            dimensions: [{
              type: "STATEMENT_PROPERTY",
              statementProperty: "actors.person.id"
            }],
            measures: [{
              name: "Interaction Count",
              aggregation: {
                type: "COUNT"
              },
              valueProducer: {
                type: "STATEMENT_PROPERTY",
                statementProperty: "object.id",
                caseSensitive: true
              }
            }]
          }
        },
        REST_REQUEST: {
          type: 'REST_REQUEST',
          httpMethod: 'POST',
          url: 'https://example.com/api/',
          username: 'user@example.com',
          password: 'sTrOnGpAsSwOrD9001',
          params: {
            'paramsPassed': true
          },
          headers: {
            'Content-Type': 'application/json'
          },
          body: 'The body can use context! -> {{ contextExampleCount }}'
        }
      };
      $scope.workflow = getWorkflowConfigFromAce();
      if (!$scope.workflow) {
        $scope.workflow = defaultWorkflow;
      }
      var ACTIONS = ['EMAIL_REPORT', 'REST_REQUEST', 'LOOP'];
      if (ACTIONS.includes(type)) {
        $scope.workflow.actions.push(tasks[type]);
      } else {
        $scope.workflow.triggers.push(tasks[type]);
      }
      setAceValue();
    };
    $scope.testRunWorkflow = function () {
      var debug = function debug() {
        return $location.path("/settings/workflows/".concat($scope.workflowId, "/debug")).search({
          ref: 'edit'
        });
      };
      $scope.debugBtn.saving = true;
      $scope.debugBtn.icon = 'spinner';
      updateWorkingModelFromEditor().then(function onSuccess() {
        if (!$scope.updatedWorkflow) {
          debug();
        } else {
          WorkflowsRegistry.update($scope.updatedWorkflow).then(function () {
            debug();
          }, handleSaveError);
        }
      }).catch(function (err) {
        Logger.error(err);
      });
    };

    // -------------------------------
    // Advanced Editor (ACE)
    // -------------------------------
    $scope.aceLoaded = function (_editor) {
      $scope.editor = _editor;
      $scope.editor.$blockScrolling = Infinity;

      // Try to set, but workflow may not be loaded yet
      setAceValue();
      var session = _editor.getSession();
      session.setMode("ace/mode/json");
      session.setTabSize(2);
      session.setUseSoftTabs(true);
    };

    /**
     * Called every 2 seconds after the ACE editor stops being changed.
     */
    $scope.aceChanged = _.debounce($scope.$evalAsync.bind($scope, function () {
      updateWorkingModelFromEditor().catch(function () {});
    }), 2500);

    /**
     * Update the $scope.updatedWorkflow model from the editor if it has changed
     * @returns {Promise} - Will be rejected if there are errors in the workflow or task validation
     */
    function updateWorkingModelFromEditor() {
      return new Promise(function (resolve, reject) {
        clearEditorErrors();
        var workflowEditorConfig = getWorkflowConfigFromAce();
        if (!workflowEditorConfig) {
          reject();
        }
        if ($scope.editorErrors.length) {
          reject();
        }
        var configsAreDifferent = !angular.equals(originalWorkflow, workflowEditorConfig);
        if (configsAreDifferent) {
          $scope.updatedWorkflow = workflowEditorConfig;
        } else {
          $scope.updatedWorkflow = null;
        }
        resolve();
      });
    }

    /**
     * Get the configuration from a workflow.
     * Delete any properties that do not need to be passed into
     * the ACE editor. Then returns that value stringified into
     * JSON string.
     *
     * @returns {JSON}
     */
    function getWorkflowConfigForAce() {
      var tmpWorkflow = angular.copy($scope.workflow);
      delete tmpWorkflow.id;
      delete tmpWorkflow.name; // We have a separate field for this; don't complicate it
      delete tmpWorkflow.lastRan;
      delete tmpWorkflow.version;
      delete tmpWorkflow.cronSchedule;
      tmpWorkflow.actions.forEach(function (action) {
        delete action.createdBy;
        delete action.createdDate;
      });
      return angular.toJson(tmpWorkflow, 2);
    }

    /**
     * Re-append all the properties that were removed in getWorkflowConfigForAce
     * and return that object.
     *
     * @returns {Object}
     */
    function getWorkflowConfigFromAce() {
      $scope.error = null;
      try {
        var workflow = JSON.parse($scope.editor.getValue());
        if (!$scope.isNewWorkflow) {
          // We only care about these checks, when updating an existing workflow
          if (!$scope.workflow || !workflow || !originalWorkflow) {
            return;
          }
        }
        return appendedWorkflow(workflow);
      } catch (error) {
        // Normal & Expected. If removed, it will break editor
        if (error.name === 'SyntaxError') {
          var maxRows = $scope.editor.getValue().split('\n').length;
          var r = error.message.lastIndexOf(' ');
          var row = Number(error.message.substring(r));
          if (row > maxRows) {
            row = maxRows - $scope.editor.getValue().substr(row).split('\n').length;
          }
          $scope.editor.getSession().setAnnotations([{
            row: row,
            column: 0,
            text: error.message,
            type: "error"
          }]);
          $scope.error = {
            save: {
              msg: 'Check the editor above to fix your configuration'
            }
          };
        }
        throw error;
      }
    }
    function appendedWorkflow(workflow) {
      var tmpWorkflow = angular.copy(workflow);
      tmpWorkflow.id = originalWorkflow.id;
      tmpWorkflow.name = $scope.workflow.name; // This could've been changed from original
      tmpWorkflow.lastRan = originalWorkflow.lastRan;
      tmpWorkflow.version = originalWorkflow.version;

      // For actions & triggers, validate each task and make sure it has the right data on it.
      ['actions', 'triggers'].forEach(function (taskType) {
        tmpWorkflow[taskType].forEach(function (task, index) {
          validateTask(task, taskType, index);
          appendTaskProperties(task, taskType, index);
        });
      });
      return tmpWorkflow;
    }

    /**
     * Validate tasks based on their type to make sure users don't save a broken workflow
     *
     * @param task {Object} - Task to validate
     * @param taskType {String} - ["actions" || "triggers"]
     * @param index {Number} - The index of "actions" or "triggers" where this task is located
     */
    function validateTask(task, taskType, index) {
      if (!task.type) {
        setEditorErrors(taskType, "".concat(taskType, " must have a \"type\" property"));
        return;
      }
      switch (task.type.toUpperCase()) {
        case 'COMPARE':
          var keys = Object.keys(task);
          var required = ['operator', 'first', 'second'];
          var missingFields = required.filter(function (e) {
            return !keys.includes(e);
          });
          if (missingFields.length) {
            setEditorErrors([taskType, {
              nth: index + 1,
              match: '"type":'
            }], "Missing the following required fields: ".concat(missingFields));
          }
          break;
      }
    }

    /**
     * Re-append properties that were removed from a particular task, whether it was
     * for simplification or whether we didn't want users to modify the property
     *
     * @param task - Task to modify
     * @param taskType - {String} ["actions" || "triggers"]
     * @param index {Number} - The index of "actions" or "triggers" where this task is located
     */
    function appendTaskProperties(task, taskType, index) {
      // Set these keys back on the task if they exist in the original workflow's tasks
      ['createdBy', 'createdDate'].map(function (key) {
        var originalWorkflowDoesNotHaveProperty = !originalWorkflow[taskType][index];
        if (originalWorkflowDoesNotHaveProperty) {
          return;
        }
        if (originalWorkflow[taskType][index][key]) {
          task[key] = originalWorkflow[taskType][index][key];
        }
      });
    }

    /**
     * Check if we have a defined workflow and if so, try to set
     * the value of the ACE editor
     */
    function setAceValue() {
      if ($scope.workflow) {
        $scope.editor.setValue(getWorkflowConfigForAce(), -1);
      }
    }
    function handleSaveError(err) {
      var message = Utils._try(function () {
        return err.data.exceptionMessage;
      }, 'Error');

      // Case: They did not pass a 'type' property for an action
      if (message.includes("missing property 'type'")) {
        setEditorErrors('actions', "You must include a 'type' property for an action.");
      }

      // Case: They did not pass a recognizable 'type' for an action
      if (message.includes("Could not resolve type id")) {
        var availableTypes = message.match(/(known type ids.*?\[.*?,\s)(.*)(])/);
        if (availableTypes) {
          availableTypes = availableTypes[2];
        }
        var unknownType = Utils._try(function () {
          return message.match(/(Could not resolve type id ')(.*?)(')/)[2];
        }, 'unknown');
        setEditorErrors('actions', "We didn't recognize type '".concat(unknownType, "'. Perhaps you meant one of: ").concat(availableTypes));
      }
      if (message.includes("An interval override may not be less than 30 minutes")) {
        setEditorErrors('intervalOverride', 'The passed intervalOverride property was less than 30 minutes. It must be greater than 30 minutes.');
      }
      if (message.includes("not a valid CronExpression")) {
        setEditorErrors('intervalOverride', 'intervalOverride is not valid. Please check your expression.');
      }
      $scope.error = {
        save: {
          msg: 'Check the editor above to fix your configuration'
        }
      };
    }

    // Called when clicking "save" on an existing workflow
    function updateWorkflow() {
      updateWorkingModelFromEditor().then(function onSuccess() {
        if (!$scope.updatedWorkflow) {
          Alerts.raiseAlert({
            type: "info",
            text: "Nothing to save.",
            autoDismissTimeout: 1500
          });
        } else {
          WorkflowsRegistry.update($scope.updatedWorkflow).then(function () {
            Alerts.raiseAlert({
              type: 'success',
              text: 'Successfully saved workflow',
              autoDismissTimeout: 2000
            });
            $location.path('/settings/workflows');
          }, handleSaveError);
        }
      }).catch(function (err) {
        Logger.error("Error while saving workflow: ", err);
      });
    }

    // Called when clicking "save" on a new workflow
    function createWorkflow() {
      var workflow = getWorkflowConfigFromAce();
      WorkflowsRegistry.create(workflow).then(function () {
        Alerts.raiseAlert({
          type: 'success',
          text: 'Successfully created new workflow',
          autoDismissTimeout: 2000
        });
        $location.path('/settings/workflows');
      }, handleSaveError);
    }
    function setEditorErrors(propertyPath, message) {
      $scope.editorErrors = AceUtils.setEditorError($scope.editor, propertyPath, message);
    }
    function clearEditorErrors() {
      $scope.editorErrors = [];
      $scope.editor.getSession().setAnnotations($scope.editorErrors);
    }
  }]).controller('WorkflowsJobCtrl', ['$scope', 'Workflows', 'wsEventNames', '$q', '$filter', '$timeout', 'WorkflowsRegistry', function ($scope, Workflows, wsEventNames, $q, $filter, $timeout, WorkflowsRegistry) {
    $scope.fetchWorkflowJobs = function () {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var params = {
        _limit: limit,
        _offset: offset
      };
      return Workflows.getAllJobs({
        params: params
      }).then(function (res) {
        var jobs = res.data.results;
        // Map the workflow names to the corresponding jobs
        return WorkflowsRegistry.getAll().then(function (_ref) {
          var results = _ref.results;
          jobs = jobs.map(function (job) {
            var jobWorkflows = results.filter(function (workflow) {
              return workflow.id === job.workflowId;
            });
            if (jobWorkflows.length === 0) {
              // This could be due to scheduled emails not being grabbed
              return null;
            }
            var name = jobWorkflows[0].name;
            return Object.assign({}, job, {
              name: name
            });
          }).filter(Boolean);
          $scope.jobs = jobs;
          return res.data;
        });
      });
    };
    $timeout(function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    }, 0);
  }]).controller('WorkflowsDebugCtrl', ['include', '$scope', 'Workflows', '$routeParams', '$route', '$location', function (include, $scope, Workflows, $routeParams, $route, $location) {
    $scope.include = include;
    $scope.workflowId = $routeParams.workflowId;
    $scope.events = [];
    Workflows.testRun($scope.workflowId, function (evt) {
      var _JSON$parse = JSON.parse(evt.data),
        message = _JSON$parse.message,
        status = _JSON$parse.status;
      status = status || 'info';
      $scope.events.push({
        message: message,
        status: status
      });
      $scope.showEditButton = $scope.events.filter(function (e) {
        return e.status === 'error';
      }).length > 0;
      $scope.$apply(); // Since EventOutput is outside digest cycle, gotta manually trigger $digest
    }, function (error) {
      $scope.error = error;
      $scope.$apply(); // Since EventOutput is outside digest cycle, gotta manually trigger $digest
    }, function () {
      $scope.done = true;
      var success = $scope.events.reduce(function (acc, curr) {
        return acc ? acc : curr.status === 'success';
      }, false);
      if (!success) {
        $scope.events.push({
          message: 'Workflow stopped running, but was not successful.',
          status: 'error'
        });
      }
      $scope.$apply(); // Since EventOutput is outside digest cycle, gotta manually trigger $digest
    });
    $scope.rerun = function () {
      return $route.reload();
    };

    // Go back to edit or list depending on where we were referred from
    $scope.back = function () {
      var id = $routeParams.workflowId;
      if ($routeParams.ref === 'edit') {
        $location.path("/settings/workflows/".concat(id)).search();
      } else {
        $location.path("/settings/workflows").search();
      }
    };
  }]);
})();
